
import React from "react";

import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import "./App.css";
import "./asset/css/style.css";
import "./asset/css/common.css";
import "./asset/css/map.css";
import ProfileInfo from "./pages/Setting/ProfileInfo";
import Measurement from "./pages/Setting/Measurement";
import Notification from "./pages/Setting/Notification";
import Team from "./pages/Setting/Team";
import SupportTicket from "./pages/Setting/SupportTicket";
import Projects from "./pages/Project/Projects";
import Wallet from "./pages/Wallet/Wallet";
import Refer from "./pages/Refer/Refer";
import Usage from "./pages/Usage/Usage";
import HelpSupport from "./pages/Help/HelpSupport";
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import Report from "./pages/Report/Report";
import MeasroDashboard from "./pages/MeasroDashboard";
import ReportNew from "./pages/Report/ReportNew";
import ProjectsDashboard from "./pages/Project/ProjectsDashboard";
import ResetPassword from "./pages/Auth/ResetPassword";
import PlanDetail from "./pages/Auth/PlanDetail";
import RegisterSuccessful from "./pages/Auth/RegisterSuccessful";
import SetPassword from "./pages/Auth/SetPassword";
import NotificationList from "./pages/Setting/NotificationList";
import Privacy from "./pages/Static/Privacy";
import Terms from "./pages/Static/Terms";

function App() {
  
 

 
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/plan-detail" element={<PlanDetail />} />
        <Route path="/register-successful" element={<RegisterSuccessful />} />
        <Route path="/about" element={<About />} />
        <Route path="/profile" element={<ProfileInfo />} />
        <Route path="/measurement" element={<Measurement />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/team" element={<Team />} />
        <Route path="/support-ticket" element={<SupportTicket />} />
        <Route path="/projectsdashboard" element={<Projects />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/refer" element={<Refer />} />
        <Route path="/usage" element={<Usage />} />
        <Route path="/help" element={<HelpSupport />} />
        <Route path="/reportnew" element={<Report />} />
        <Route path="/report/:id" element={<ReportNew />} />
        <Route path="/projects" element={<ProjectsDashboard />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/home" element={<MeasroDashboard />} />
        <Route path="/notification-list" element={<NotificationList />} />



        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </Router>
  );
}

export default App;